// extracted by mini-css-extract-plugin
module.exports = {"btn":"Btn_btn__3iWZQ"};